import React from 'react';
import Logo from './../assets/images/logo_auth.png';
import ClipLoader from 'react-spinners/ClipLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import useCheckActivateUser from '../hooks/useCheckActivateUser';

const Activation = () => {

  const { isLoading, isSuccess } = useCheckActivateUser()


  return (
    <div className="page not-hide-mobile">
      <div className="main container-fluid">
        <div className="row">
          <div className="col-lg-8 col-md-12 d-flex align-items-start">
            <div className="px-5 pt-5 mt-5">
              <img width="80" height="80" src={Logo} alt='Logo MAP' />
              <h3 className="mt-3 text-light">Market Auction Price</h3>
              <p className="mt-3 pr-5 text-light">
                Market Auction Price (MAP) adalah aplikasi yang <br></br> menyediakan informasi harga pasaran mobil
                lelang <br></br> terlengkap di Indonesia. Buatlah keputusan yang tepat <br></br> dan menguntungkan,
                karena semua informasi harga <br></br> pasaran mobil yang mau Anda beli atau jual ada disini.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 px-5 py-4">
            {!isLoading ? (
              <div className="form-group form-register bg-white rounded d-flex justify-content-start flex-column align-items-center  py-5 h-100">
                {isSuccess ? (
                  <>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        fontSize: 120,
                        color: '#5C0989',
                        marginTop: 10,
                        marginBottom: 20,
                      }}
                    />
                    <h4 className="mb-2">Verifikasi Berhasil</h4>
                    <p>
                      <span>Silahkan</span>
                      <Link to='/login' style={{ color: '#82be2a', marginLeft: 4, }}>masuk disini</Link>
                    </p>
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{
                        fontSize: 120,
                        color: '#5C0989',
                        marginTop: 10,
                        marginBottom: 20,
                      }}
                    />
                    <h4 className="mb-2">Verifikasi Gagal</h4>
                  </>
                )}
              </div>
            ) : (
              <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                <ClipLoader loading size={100} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activation;
